export const getYear = state => state.reportVehicleResults.getIn(['list', 'year'])
export const getData = state => state.reportVehicleResults.getIn(['list', 'data'])
export const getFetching = state => state.reportVehicleResults.getIn(['list', 'fetching'])
export const getError = state => state.reportVehicleResults.getIn(['list', 'error'])

export const getDetailsData = state => state.reportVehicleResults.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportVehicleResults.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportVehicleResults.getIn(['details', 'error'])
